export default new (class EquipmentDto {
  GetCoreInfosDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        MeterModule2G: preAssembly.Meter.MeterModule2G,
        MeterModule: preAssembly.Meter.MeterModule,
        InstallationType: preAssembly.Mode,
        Hardware: preAssembly.HW_Version,
        Firmware: preAssembly.FW_Version,
        ManufacturingDate: preAssembly.Fab_Date,
        ActivationDelay: preAssembly.ActivationDelay,
        Brand: preAssembly.Installer,
      };
    }
    return p;
  }

  GetRadioDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        CurrentRadioMode: preAssembly.Mode_radio,
        QOS: preAssembly.QoS,
        TransmissionPower: preAssembly._2GConfigInfos.Tx_Power,
        UplinkChannel: "To be detailed",
        UplinkModulation: "To be detailed",
        DownlinkChannel: "To be detailed",
        DownlinkModulation: "To be detailed",
      };
    }
    return p;
  }

  GetPairingDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        MeterId: preAssembly.Meter.MeterIdentifier,
        MechanicalIndex: preAssembly.MechanicalIndex,
        PulseWeight: preAssembly.PulseWeight,
        ElectronicIndex: preAssembly.ElectronicIndex,
        Date: preAssembly.Date,
      };
    }
    return p;
  }
  GetMeasurementDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        ElectronicIndex: preAssembly.ElectronicIndex,
        Date: preAssembly.Date,
        PulseWeight: preAssembly.PulseWeight,
        PeriodRef: preAssembly.Periode_Ref,
      };
    }
    return p;
  }

  GetMetrologicalDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        WaterBackflow: "To be detailed",
        DebitHaut: "To be detailed",
        DebitBas: "To be detailed",
        PlageDebit: "To be detailed",
        Description: "To be detailed",
      };
    }
    return p;
  }

  GetMeteringDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        Technology: "To be detailed",
        MeasurementCycle: preAssembly.Pas_Mesure,
        ActivatedFrames: "To be detailed",
        FramesRedundancy: "To be detailed",
      };
    }
    return p;
  }

  GetSecurityDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        UtilityCode: preAssembly.UtilityCode,
        KencKeysetId: preAssembly._2GConfigInfos.KencKeySetId,
        CurrentKencIndex: preAssembly._2GConfigInfos.KencId,
      };
    }
    return p;
  }

  GetOrderInfoDetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        UtilityCode: preAssembly.UtilityCode,
        KencKeysetId: preAssembly._2GConfigInfos.KencKeySetId,
        CurrentKencIndex: preAssembly._2GConfigInfos.KencId,
      };
    }
    return p;
  }

  GetTimeReferencesdetails(preAssembly) {
    var p = {};

    if (preAssembly) {
      p = {
        ReferenceTime2G: preAssembly._2GConfigInfos.HR,
        ReferenceTime1G: preAssembly._1GConfigInfos.HR1G,
      };
    }
    return p;
  }
})();
